import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const closeReturn = {
  name: "closeReturn" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
